<div
  class="Col--name d-flex"
  [style.width]="colWidth - (hasParentGroup ? 97 : 70) + 'px'"
  [class.has-description]="data.description"
>
  @switch (data.type) {
    @case ('PARENT') {
      <a
        data-dd-action-name="name-cell-renderer.toggle-parent-group-button"
        (click)="onToggleExpanded()"
        class="parent-group-name"
        [title]="data.parentGroup"
      >
        {{ data.parentGroup }}
      </a>
    }
    @case ('GROUP') {
      <div class="justify-content-between d-flex flex-grow-1">
        <div class="group">
          <a
            data-dd-action-name="name-cell-renderer.toggle-group-button"
            (click)="onToggleExpanded()"
            class="group-name"
            [style.max-width]="colWidth - 158 + 'px'"
            [class.clickable]="data.assetCount"
            [title]="data.groupName"
            >{{ data.groupName }}</a
          >
          <span class="badge rounded-pill bg-light text-dark ms-2">
            {{ data.assetCount }}</span
          >
        </div>
        @if (routerLink(); as link) {
          <button
            data-dd-action-name="name-cell-renderer.edit-group-button"
            type="button"
            [routerLink]="link"
            [fragment]="fragment()"
            class="btn btn-outline"
            title="Edit Group"
          >
            <i-lucide name="edit2"></i-lucide>
          </button>
        }
      </div>
    }
    @case ('ASSET') {
      <div>
        <a
          data-dd-action-name="name-cell-renderer.asset-link"
          [routerLink]="routerLink()"
          [fragment]="fragment()"
          [title]="data.name"
        >
          @if (data.code) {
            {{ data.code }}
          }
          {{ data.name }}</a
        >
      </div>
      @if (data.description) {
        <div class="description">
          {{ data.description }}
        </div>
      }
    }
  }
</div>
